// projects/humanresources-payroll/src/assets/i18n/*/hr-pay-wage-type.json
export class HrPayWageTypeKey {
    private static readonly keyPrefix = 'hrPayWageType';
    public static pageHeader = `${HrPayWageTypeKey.keyPrefix}.pageHeader`;
    public static listHeader = `${HrPayWageTypeKey.keyPrefix}.listHeader`;
    public static startDate = `${HrPayWageTypeKey.keyPrefix}.startDate`;
    public static endDate = `${HrPayWageTypeKey.keyPrefix}.endDate`;
    public static group = `${HrPayWageTypeKey.keyPrefix}.group`;
    public static code = `${HrPayWageTypeKey.keyPrefix}.code`;
    public static text = `${HrPayWageTypeKey.keyPrefix}.text`;
    public static grossNet = `${HrPayWageTypeKey.keyPrefix}.grossNet`;
    public static gross = `${HrPayWageTypeKey.keyPrefix}.gross`;
    public static net = `${HrPayWageTypeKey.keyPrefix}.net`;
    public static country = `${HrPayWageTypeKey.keyPrefix}.country`;
    public static workArea = `${HrPayWageTypeKey.keyPrefix}.workArea`;
    public static workSubArea = `${HrPayWageTypeKey.keyPrefix}.workSubArea`;
    public static wageTypeInfoEntry = `${HrPayWageTypeKey.keyPrefix}.wageTypeInfoEntry`;
    public static characteristicScaleInformation = `${HrPayWageTypeKey.keyPrefix}.characteristicScaleInformation`;
    public static valuationInformation = `${HrPayWageTypeKey.keyPrefix}.valuationInformation`;
    public static behavioralInformation = `${HrPayWageTypeKey.keyPrefix}.behavioralInformation`;
    public static formulaInformation = `${HrPayWageTypeKey.keyPrefix}.formulaInformation`;
    public static wageTypeCode = `${HrPayWageTypeKey.keyPrefix}.wageTypeCode`;
    public static wageTypeText = `${HrPayWageTypeKey.keyPrefix}.wageTypeText`;
    public static wageTypeGroup = `${HrPayWageTypeKey.keyPrefix}.wageTypeGroup`;
    public static scale = `${HrPayWageTypeKey.keyPrefix}.scale`;
    public static payrollName = `${HrPayWageTypeKey.keyPrefix}.payrollName`;
    public static grossWageEquity = `${HrPayWageTypeKey.keyPrefix}.grossWageEquity`;
    public static numberOfIterations = `${HrPayWageTypeKey.keyPrefix}.numberOfIterations`;
    public static WorkAreaWageGroup = `${HrPayWageTypeKey.keyPrefix}.WorkAreaWageGroup`;
    public static employeeType = `${HrPayWageTypeKey.keyPrefix}.employeeType`;
    public static employeeSubType = `${HrPayWageTypeKey.keyPrefix}.employeeSubType`;
    public static employeeTypeWageGroup = `${HrPayWageTypeKey.keyPrefix}.employeeTypeWageGroup`;
    public static selectPlaceHolder = `${HrPayWageTypeKey.keyPrefix}.selectPlaceHolder`;
    public static shortText = `${HrPayWageTypeKey.keyPrefix}.shortText`;
    public static longText = `${HrPayWageTypeKey.keyPrefix}.longText`;
    public static afterCumulative = `${HrPayWageTypeKey.keyPrefix}.afterCumulative`;
    public static numberOfIteration = `${HrPayWageTypeKey.keyPrefix}.numberOfIteration`;
    public static percentageOfDifference = `${HrPayWageTypeKey.keyPrefix}.percentageOfDifference`;
    public static grossWage = `${HrPayWageTypeKey.keyPrefix}.grossWage`;
    public static correspondingGrossWt = `${HrPayWageTypeKey.keyPrefix}.correspondingGrossWt`;
    public static true = `${HrPayWageTypeKey.keyPrefix}.true`;
    public static false = `${HrPayWageTypeKey.keyPrefix}.false`;
    public static wtCharacteristic = `${HrPayWageTypeKey.keyPrefix}.wtCharacteristic`;
    public static wtFieldEntries = `${HrPayWageTypeKey.keyPrefix}.wtCharacteristic.wtFieldEntries`;
    public static next = `${HrPayWageTypeKey.keyPrefix}.next`;
    public static prev = `${HrPayWageTypeKey.keyPrefix}.prev`;
    public static cancel = `${HrPayWageTypeKey.keyPrefix}.cancel`;
    public static formulaScript = `${HrPayWageTypeKey.keyPrefix}.formulaScript`;
    public static workAreaSubareaText = `${HrPayWageTypeKey.keyPrefix}.workAreaSubareaText`;
    public static employeeTypeSubtypeText = `${HrPayWageTypeKey.keyPrefix}.employeeTypeSubtypeText`;
}
